import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {createLog} from '@util/logs'
import useAccounts from '@hook/useAccounts'
import WizButton from '@component/buttons/WizButton'

interface IProps {
    className?: string
}

const UserLogOutOperations = ({className}: IProps) => {
    const t = useTranslation()
    const {logout, removeStorage: removeAccountsStorage} = useAccounts()

    const onClickSignOut = async () => {
        createLog('event', 'navigation_logout')
        logout()
    }

    const onClickSignOutAll = async () => {
        createLog('event', 'navigation_logout_all')
        removeAccountsStorage()
        logout()
    }
    return (
        <div className={'p-[20px] flex gap-x-[10px] items-center'}>
            <WizButton
                onClick={() => onClickSignOutAll()}
                text={t('globalNavigation.multiLogin.logout.all')}
                buttonType={'border'}
                size={'small'}
                className={'w-full'}
            />
            <WizButton
                onClick={() => onClickSignOut()}
                text={t('globalNavigation.my.menu.logout')}
                buttonType={'border'}
                size={'small'}
                className={'w-full'}
            />
        </div>
    )
}
export default UserLogOutOperations
